import { useMutation } from '@tanstack/react-query'

import { enforceSaml } from '@src/api'
import { DefaultApiEnforceSamlRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useEnforceSaml = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiEnforceSamlRequest) =>
      enforceSaml(axiosInstance, params),
  })
}
